namespace Matrix.Data {
    export class AccountGroupAccountsColumns {
        static columnsKey = 'Data.AccountGroupAccounts';
    }
}
